import type { ComponentPropsWithoutRef } from 'react'
import { LosseContent } from '@ubo/losse-sjedel'

export default function Content({ ...rest }: ComponentPropsWithoutRef<'div'>) {
  return <LosseContent {...rest}>{rest.children}</LosseContent>
}
